import { Fragment, useState } from "react";

import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { operatorOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

import type { IAppsSDKsFilterItem } from "../../../types/commonFiltersDto";
import type { IAppsSDKsFilterDescriptionDto } from "../../../types/descriptionDto";
import { hasSameSdkObject } from "../../../utils";
import InclusionSdkChip from "../../InclusionSdkChip/InclusionSdkChip";
import SdkModal from "../../modals/SdkModal/SdkModal";

import { StyledSDKValueDivider } from "./styles";

const AppSdkFilterResult = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseModelProps<IAppsSDKsFilterItem[], IAppsSDKsFilterDescriptionDto>) => {
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<IAppsSDKsFilterItem | null>(null);

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleApply = (item: IAppsSDKsFilterItem, selectedItem?: IAppsSDKsFilterItem) => {
        const sdkValues = (value || []).map((sdkItem: IAppsSDKsFilterItem) => {
            if (selectedItem && hasSameSdkObject(sdkItem, selectedItem)) {
                return item;
            }

            return sdkItem;
        });
        onFilterUpdate(sdkValues);
        setIsOpenModal(false);
    };

    const handleOnDelete = (selectedItem: IAppsSDKsFilterItem) => {
        const filteredSdks = value?.filter((item: IAppsSDKsFilterItem) => !hasSameSdkObject(item, selectedItem));
        onFilterUpdate(filteredSdks && filteredSdks.length > 0 ? filteredSdks : undefined);
    };

    const handleOnEdit = (selectedItem: IAppsSDKsFilterItem) => {
        setSelectedItem(selectedItem);
        setIsOpenModal(true);
    };

    if (value?.length === 0) {
        return null;
    }

    return (
        <div>
            <SdkModal
                isOpen={isOpenModal}
                selected={selectedItem}
                onClose={handleClose}
                onCancel={handleClose}
                onApply={handleApply}
                options={filter.options}
                value={value}
            />

            {value && value?.length > 0
                ? value?.map((sdk: IAppsSDKsFilterItem, i) => (
                      <Fragment key={`${sdk.inclusion}-${sdk.operator}-${sdk.sdks[0]}`}>
                          {i > 0 ? <StyledSDKValueDivider>{operatorOptionMap.and}</StyledSDKValueDivider> : null}
                          <InclusionSdkChip
                              item={sdk}
                              onEdit={handleOnEdit}
                              onDelete={handleOnDelete}
                          />
                      </Fragment>
                  ))
                : null}
        </div>
    );
};

export default AppSdkFilterResult;
